
import L, { LatLngExpression } from "leaflet";
import { useEffect, useState } from "react";
import { Marker, Popup, useMap, Tooltip } from "react-leaflet";
import DeviceMonitor from "../../../components/device/DeviceMonitor";
import useVitalsSocket from "../../../hooks/useVitalsSocket";
import useSentioSocket from "../../../hooks/useSentioSocket";
import { Device } from "../../../interfaces/Device";
import { memo } from "react";
import "./DeviceMarker.css";
import {parmMap} from "../../Home/LiveDashboard"

interface Props {
    device: Device;
    setDevices?: (devices: Device[]) => void;
	updateActivityStatus?: (device_id: string, timestamp: string, monitorId?: string) => void;
    isVisible: boolean;
    showVitals?: boolean;
    monitorId?: string;
}
const DeviceMarker = ({ device, setDevices, isVisible, updateActivityStatus, showVitals = true, monitorId }: Props) => {
    const { gpsLocation } = useVitalsSocket({
        device,
    });

    const [dataPacket, setDataPacket] = useState<any>(null);
    const [gpsLocationFound, setGpsLocationFound] = useState(false);

    useSentioSocket({ device, setDataPacket, mode: "heartbeat" });

    const map = useMap();

    useEffect(() => {
        if (dataPacket && dataPacket.device_id && dataPacket.timestamp && updateActivityStatus) {
            updateActivityStatus(dataPacket.device_id, dataPacket.timestamp, dataPacket.monitor_id);
        }
    }, [dataPacket, updateActivityStatus]);

    useEffect(() => {
        //console.log("DeviceMarker useEffect", device.device_id, gpsLocation);
        if (gpsLocation && !gpsLocationFound) {
            const visibleMarkers: { getLatLng: () => LatLngExpression }[] = [];
            map.eachLayer(function (layer) {
                if (layer instanceof L.Marker) {
                    visibleMarkers.push(layer);
                }
            });

            // Ensure there's at least one visible Marker
            if (visibleMarkers.length > 0) {
                // Create bounds from first Marker then extend it with the rest
                const markersBounds = L.latLngBounds([
                    visibleMarkers[0].getLatLng(),
                ]);
                visibleMarkers.forEach((marker) => {
                    markersBounds.extend(marker.getLatLng());
                });

                // Fit the map with the visible markers bounds
                map.flyToBounds(markersBounds, {
                    padding: L.point(36, 36),
                    animate: true,
                });
            }
            setGpsLocationFound(true);
        }
    }, [gpsLocation, gpsLocationFound, map]);
    // console.log ("map:", device)
    const availableParams = parmMap[device.device_model] ? parmMap[device.device_model].parms : [];

    //console.log("Mapped parm:", device.device_id, isVisible, gpsLocation)
    return (
        <>
            {gpsLocation && (
                <Marker position={[gpsLocation.lat, gpsLocation.lng]}>
                <Tooltip direction="right" offset={[0, 0]} opacity={1} permanent>
                    <div>
                        <div>{device.nickname ? device.nickname : device.device_id}</div>
                        {(dataPacket?.monitor_id || monitorId) && (
                            <div style={{ fontSize: '0.8em', opacity: 0.8 }}>{dataPacket?.monitor_id || monitorId}</div>
                        )}
                    </div>
                </Tooltip>

                    { showVitals && <Popup minWidth={400} autoClose={false}>
                            <DeviceMonitor
                                device={device}
                                setDevices={setDevices}
                                compact
                                fullWidth
                                type="mapmonitor"
                                availableParams={availableParams}
                                isVisible={isVisible}
                                updateActivityStatus={updateActivityStatus}
                            />
                    </Popup>}
                </Marker>
            )}
        </>
    );
};

export default memo(DeviceMarker);
